import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-supported',
  templateUrl: './not-supported.component.html',
  styleUrls: ['./not-supported.component.css']
})
export class NotSupportedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
